import React from "react";
import { useNavigate } from "react-router-dom";

const RelatedProducts = ({ relatedProducts }) => {
    const navigate = useNavigate();

    const handleProductClick = (productId) => {
        navigate(`/products/${productId}`);
    };

    return (
        <div className="relative px-4 sm:px-8 lg:px-24 py-8">
            {/* Background */}
            <div className="absolute inset-0 -z-10 h-full w-full bg-[radial-gradient(125%_125%_at_50%_10%,#000_40%,#63e_100%)]"></div>

            {/* Related Products Section */}
            <section className="flex flex-col">
                {/* Header Section */}
                <div className="border-b-2 flex justify-between items-center py-4">
                    <h1 className="text-3xl sm:text-4xl font-bold text-white">Related Products</h1>
                    <button className="text-xl sm:text-2xl font-semibold text-white hover:text-pink-300 transition duration-300">
                        View All
                    </button>
                </div>

                {/* Products Grid */}
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6 mt-8 p-3">
                    {relatedProducts?.slice(0, 5).map((product) => (
                        <div
                            key={product?._id}
                            className="text-center cursor-pointer"
                            onClick={() => handleProductClick(product?._id)} // Navigate on click
                        >
                            <img
                                className="border shadow-md shadow-pink-500 border-pink-900 rounded w-full h-[250px] sm:h-[300px] lg:h-[350px] object-cover"
                                src={product?.imageUrl}
                                alt={product?.title}
                            />
                            <div className="flex justify-between items-center mt-4 px-2">
                                <p className="text-sm sm:text-base lg:text-lg text-white">{product?.title}</p>
                                <p className="text-sm sm:text-base lg:text-lg text-white">{product?.discountedPrice} ₹</p>
                            </div>
                        </div>
                    ))}
                </div>
            </section>
        </div>
    );
};

export default RelatedProducts;
